<template>
  <div class="fixed inset-0 z-1000">
    <CockpitDialog
      title="添加物资"
      left="580px"
      width="990px"
      height="650px"
      top="120px"
      @close="visible = false"
    >
      <div class="h-full flex flex-col">
        <div class="flex-auto h-0 overflow-hidden">
          <div class="flex mb-20px mr-10px">
            <el-input
              size="small"
              class="mr-10px !w-50"
              placeholder="请输入物资名称/物资编码"
              v-model="searchData.keywords"
              clearable
            ></el-input>
            <el-select
              popper-class="visualization-select-popper"
              size="small"
              class="mr-10px !w-50"
              placeholder="请选择物资类型"
              v-model="searchData.suppliesType"
              clearable
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              popper-class="visualization-select-popper"
              v-model="searchData.suppliesCategory"
              size="small"
              class="mr-10px !w-50"
              placeholder="请选择物资类别"
              clearable
            >
              <el-option
                v-for="(item, index) in category"
                :key="index"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              popper-class="visualization-select-popper"
              size="small"
              class="mr-10px !w-50"
              placeholder="请选择所属区域"
              v-model="searchData.areaId"
              clearable
            >
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              popper-class="visualization-select-popper"
              size="small"
              class="mr-10px !w-50"
              placeholder="请选择物资点位"
              v-model="searchData.suppliesSite"
              clearable
            >
              <el-option
                v-for="(item, index) in materialPointList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <button
              class="handle_btn search mr-10px"
              size="small"
              type="button"
              @click="handleSearch"
            >
              搜索
            </button>
            <button class="handle_btn" size="small" type="button" @click="resetText">
              重置
            </button>
          </div>
          <el-table
            ref="table"
            :data="tableData"
            class="w-full"
            :height="tableHeight"
            v-loading="loading"
            @selection-change="handleSelection"
            :row-key="(row) => row.id"
          >
            <el-table-column
              :reserve-selection="multiple"
              type="selection"
              width="50"
              v-if="multiple"
              :selectable="isDisabled"
            ></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="物资名称" prop="name" show-overflow-tooltip />
            <el-table-column label="物资编码" prop="codeStr" show-overflow-tooltip />
            <el-table-column label="物资类别" prop="suppliesCategoryStr" show-overflow-tooltip />
            <el-table-column label="物资类型" prop="suppliesTypeName" show-overflow-tooltip />
            <el-table-column label="规格型号" prop="spec" show-overflow-tooltip />
            <el-table-column label="物资点位" prop="suppliesSiteName" show-overflow-tooltip />
            <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip />
          </el-table>
          <el-pagination
            background
            @size-change="baseTableSizeChange"
            @current-change="baseTableCurrentChange"
            :current-page.sync="basePageConfig.SkipCount"
            :page-size.sync="basePageConfig.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="total"
            class="float-right mt-10px mb-10px ml-10px"
          ></el-pagination>
        </div>
        <div class="text-center py-10px flex justify-center" v-if="multiple">
          <button class="handle_btn mr-10px" @click="handleOk">
            <span>确定</span>
          </button>
          <button class="handle_btn" @click="visible = false">
            <span>取消</span>
          </button>
        </div>
      </div>
    </CockpitDialog>
  </div>
</template>

<script type="text/babel">
import { DataCategoryApi } from '@wiz-api/data-category-management'
import {
  SuppliesTypeApi,
  SuppliesSiteApi,
  SuppliesManagementApi,
} from '@wiz-api/emergency-management'
import { AreaApi } from '@wiz-api/area-management'
import dayjs from 'dayjs'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const suppliesManagementApi = new SuppliesManagementApi()
const suppliesSiteApi = new SuppliesSiteApi()
const dataCategoryApi = new DataCategoryApi()
const suppliesTypeApi = new SuppliesTypeApi()
const areaApi = new AreaApi()

export default {
  name: 'emergency-material-dialog',
  components: {
    CockpitDialog,
  },
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: true,
    },
    dataList: {
      default: [],
    },
  },
  data() {
    return {
      typeList: [],
      category: [],
      materialPointList: [],
      areaList: [],

      visible: true,
      tableData: [],
      loading: false,
      total: 0,
      searchData: {},
      basePageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 100px)'
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  created() {
    this.getAreaList()
    this.getType()
    this.getRegulationType()
    this.getPointList()
    this.findList()
  },
  methods: {
    // 禁用复选框
    isDisabled(row) {
      const selection = this.dataList.map((item) => {
        return item.id
      })
      if (selection.includes(row.id)) {
        return 0
      }
      return 1
    },
    // 设置选中
    setSelect() {
      this.dataList.forEach((item) => {
        this.$refs.table.toggleRowSelection({ id: item.id })
      })
    },
    // 选中结果事件
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        if (item.creationTime) {
          item.creationTime = dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
        }
        if (item.expirationDate) {
          item.expirationDate = dayjs(item.expirationDate).format('YYYY-MM-DD HH:mm:ss')
        }
        if (item.factoryDate) {
          item.factoryDate = dayjs(item.factoryDate).format('YYYY-MM-DD HH:mm:ss')
        }
        if (item.factoryExpirationDate) {
          item.factoryExpirationDate = dayjs(item.factoryExpirationDate).format(
            'YYYY-MM-DD HH:mm:ss'
          )
        }
        if (item.productionDate) {
          item.productionDate = dayjs(item.productionDate).format('YYYY-MM-DD HH:mm:ss')
        }
        return item
      })
    },
    async getPointList() {
      const params = {
        skipCount: 0,
        maxResultCount: 99,
      }
      const [err, data] = await suppliesSiteApi.getList(params)
      if (!err) {
        this.materialPointList = data.items
      }
    },
    // 从数据字典获取制度类别
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['SuppliesCategory'],
        includeDetails: true,
      })
      if (err) return
      // 字典-事故类型
      this.category = res[0]?.dataItems
    },
    // 获取物资类型
    async getType() {
      const params = {
        skipCount: 0,
        maxResultCount: 99,
      }
      const [err, data] = await suppliesTypeApi.getList(params)
      if (!err) {
        this.typeList = data.items
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索 equip 设备设施 base 作业活动
    handleSearch() {
      this.basePageConfig.SkipCount = 1
      this.findList()
    },
    // 页码改变
    baseTableSizeChange(MaxResultCount) {
      this.basePageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    baseTableCurrentChange(SkipCount) {
      this.basePageConfig.SkipCount = SkipCount
      this.findList()
    },
    // 作业活动列表
    async findList() {
      const data = {
        maxResultCount: this.basePageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.basePageConfig.SkipCount - 1) * this.basePageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
        areaId: [this.searchData.areaId],
      }
      this.loading = true
      const [err, res] = await suppliesManagementApi.getList(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    handleOk() {
      const data = this.selectionData.map((item) => {
        return {
          ...item,
          goodsId: item.id,
          category: item.suppliesCategory,
          categoryText: item.suppliesCategoryStr,
          specsNo: item.spec,
          suppliesSiteText: item.suppliesSiteName,
          factoryCode: item.no,
          factoryDate: item.productionDate,
          factoryExpirationDate: item.expirationDate,
        }
      })
      this.$emit('handleOk', data)
      this.visible = false
    },
  },
}
</script>

<style scoped lang="scss">
.handle_btn {
  height: 32px;
  width: 96px;
  border-radius: 32px;
  background: linear-gradient(180deg, #137ee566 0%, #19a4da66 100%),
    linear-gradient(-180deg, #05bdff00 0%, #3bfff566 100%);
  box-shadow: inset 0px 1px 15px 0px #77c4ff33;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #4dc2d2;
  }
}
.search {
  background: #4dc2d2;
}
.handle_btn[disabled] {
  cursor: no-drop;
}
::v-deep .el-dialog__body {
  padding-bottom: 10px;
}
</style>
